import { observer } from 'mobx-react-lite'
import { match } from '@/utils/pattern-match-util'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { ConsultationPendingBookingModalContainer } from '@/features/jobs/details/components/ConsultationPendingBookingModal/ConsultationPendingBookingModalContainer'
import { JobDocumentsSectionContainer } from '@/features/jobs/details/components/JobDocumentsSection/JobDocumentsSectionContainer'
import { JobSections } from '@/features/jobs/details/components/JobSections'
import { OverviewPaneContainer } from '@/features/jobs/details/components/JobSections/OverviewPane/OverviewPaneContainer'
import { IntakePaneContainer } from '@/features/jobs/details/components/JobSections/IntakePane/IntakePaneContainer'
import { NotesPaneContainer } from '@/features/jobs/details/components/JobSections/NotesPane/NotesPaneContainer'
import { ActivityPaneContainer } from '@/features/jobs/details/components/JobSections/ActivityPane/ActivityPaneContainer'

export interface JobSectionsContainerProps {
  vm: JobDetailsViewModel
}

export const JobSectionsContainer = observer(function JobSectionsContainer({
  vm,
}: JobSectionsContainerProps) {
  return (
    <JobSections
      tabs={vm.sectionTabs}
      current={vm.currentSection}
      onSelectSection={vm.setSection}
      modals={
        <ConsultationPendingBookingModalContainer
          vm={vm.consultationVm.consultationPendingBookingModalVm}
        />
      }
    >
      {match(vm.currentSection, {
        overview: () => <OverviewPaneContainer vm={vm} />,
        documents: () => <JobDocumentsSectionContainer vm={vm} />,
        intake: () => <IntakePaneContainer vm={vm} />,
        notes: () => <NotesPaneContainer vm={vm} />,
        activity: () => <ActivityPaneContainer vm={vm} />,
      })}
    </JobSections>
  )
})
